import { getTaskworldFrontendUrl } from '../Env'

export function redirectToTaskworld() {
  window.location.href = getTaskworldFrontendUrl()
}

export const termUrl = 'https://taskworld.com/legal'
